import { render, staticRenderFns } from "./indexBanner.vue?vue&type=template&id=28f6b17a&scoped=true"
import script from "./indexBanner.vue?vue&type=script&lang=js"
export * from "./indexBanner.vue?vue&type=script&lang=js"
import style1 from "./indexBanner.vue?vue&type=style&index=1&id=28f6b17a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6b17a",
  null
  
)

export default component.exports